import type { CalculateChildrenSavingsRequest } from 'aem-libs-api/src/services/rfa-depositcalc/v1/types'
import { createInletStore } from 'aem-libs-react-components/src/store/createInletStore'

import type { ChildrenSavingsCalculatorParams } from './types'

export const childrenSavingsStore = createInletStore(
  null as unknown as CalculateChildrenSavingsRequest,
  null,
  (set) => ({
    setInitialAmount: (initialAmount: number) => set((state) => ({ ...state, initialAmount })),
    setMonthlyAmount: (monthlyAmount: number) => set((state) => ({ ...state, monthlyAmount })),
    setAge: (age: number) => set((state) => ({ ...state, age }))
  })
)

export const initStore = (params: ChildrenSavingsCalculatorParams) =>
  childrenSavingsStore
    .initialize({
      initialAmount: params.initialAmountConfig.default,
      monthlyAmount: params.monthlyAmountConfig.default,
      age: params.ageConfig.default
    })
    .use()
